import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import RichText from '../Prismic/RichText';
import { prismicImage } from 'src/common/utils/prismic-image';
import { localiseUrl } from 'src/common/utils/format-localised-url';

import './SignInPartial.scss';

const SignInPartial = (props) => {
  const backgroundImage = prismicImage(props.media.fabletDown ? props.backgroundImage.mobile : props.backgroundImage);
  const url = `/login?return_to=${props.returnToUrl}`;

  if (props.isUserLoggedIn) {
    return null;
  }
  return (
    <section className="sign-in-partial">
      <a
        onClick={props.handleClick}
        className="sign-in-partial__background"
        href={localiseUrl(props.country, url)}
        style={{
          backgroundColor: backgroundImage ? null : props.backgroundColor,
          backgroundImage: backgroundImage && `url("${backgroundImage}")`
        }}>
        <div className={cx('sign-in-partial__content', {
          [`color-${props.textColor}`]: props.textColor
        })}>
          <div className="sign-in-partial__title">{props.title}</div>
          <RichText className="sign-in-partial__description" fields={props.description} />
        </div>
      </a>
    </section>
  );
};

SignInPartial.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.array,
  country: PropTypes.object.isRequired,
  returnToUrl: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundImage: PropTypes.shape({
    mobile: PropTypes.object
  }),
  media: PropTypes.shape({
    fabletDown: PropTypes.bool
  }).isRequired,
  isUserLoggedIn: PropTypes.bool.isRequired,
  handleClick: PropTypes.func,
};

export default SignInPartial;



// WEBPACK FOOTER //
// ./src/client/js/view/components/SignInPartial/SignInPartial.js